import { useState } from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import CompactDataTable from 'src/components/CompactDataTable';
import ListActionBar from 'src/components/ListActionBar';
import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import { useInfinitePolicyVersions } from 'src/hooks/environmentWdacPolicy';
import { VERSION_COLUMNS } from './constants';
import PolicyVersionModal from './PolicyVersionModal';

// The version stays set while the dialog closes so its title does not empty mid-animation.
const CLOSED_MODAL = { open: false, version: null };

const PolicyVersions = () => {
  const { policyId } = useParams();
  const [searchValue, setSearchValue] = useState('');
  const [modal, setModal] = useState(CLOSED_MODAL);

  const versionsQuery = useInfinitePolicyVersions({
    envPolicyId: policyId,
    search: searchValue,
    limit: EXPANDED_ROWS_LIMIT,
  });

  const rows = versionsQuery.data?.pages?.flatMap(page => page.results || []) || [];

  const [sentryRef] = useInfiniteScroll({
    loading: versionsQuery.isFetchingNextPage,
    hasNextPage: !!versionsQuery.hasNextPage,
    onLoadMore: versionsQuery.fetchNextPage,
    rootMargin: '0px 0px 400px 0px',
  });

  return (
    <Box>
      <ListActionBar
        onSearch={setSearchValue}
        searchPlaceholder="Search by version, name or hash..."
      />
      <CompactDataTable
        columns={VERSION_COLUMNS}
        rows={rows}
        isLoading={versionsQuery.isLoading}
        isFetching={versionsQuery.isFetching}
        lastElementRef={sentryRef}
        searchValue={searchValue}
        onRowClick={version => setModal({ open: true, version })}
      />

      <PolicyVersionModal
        open={modal.open}
        version={modal.version}
        onClose={() => setModal(previous => ({ ...previous, open: false }))}
      />
    </Box>
  );
};

export default PolicyVersions;
